export default __webpack_public_path__ + "static/media/gas-load.1d97a29f.svg";